export default __webpack_public_path__ + "static/Bittrex-5371f967a19d0738b64ccaa49787df69.png";